import React, { useState, useEffect } from 'react';
import { styled } from '@mui/system';

import Dialog from '@mui/material/Dialog';

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { ThemeProvider, createTheme } from '@mui/material/styles'; 
import dayjs from 'dayjs';

const theme = createTheme();


const CustomDialogTitle = styled(DialogTitle)(({ theme }) => ({
  fontSize: "16px",
  maxWidth: "864px",
  background: "#3c8dbc",
  color: "#fff",
}));
const CustomDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: "#eaf7fdcc",
}));
const AddVendor = (props) => {
  const [open, setOpen] = React.useState(false);
  const [vendorName, setVendorName] = useState('');
  const [vendorContactPerson, setVendorContactPerson] = useState('');
  const [vendorEmail, setVendorEmail] = useState('');
  const [vendorAddress, setVendorAddress] = useState('');
  const [vendorGST, setVendorGST] = useState('');
  const [vendorCost, setVendorCost] = useState(0);
  const [vendorQuotes, setVendorQuotes] = useState('');
  const [approved, setApproved] = useState('');

  const some = props.noOfVendors && props.noOfVendors.length;

  useEffect(() => {
    if (some > 0) {
      props.noOfVendors.map((insert) => {
        if (insert.poStatus === 'Yes') {
          setApproved(insert.vendorStatus);
        }
      });
    }
  }, [props.noOfVendors, some]);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleName = (e) => {
    setVendorName(e.target.value);
  };
  const handleEmail = (e) => {
    setVendorEmail(e.target.value);
  };
  const handleContactPerson = (e) => {
    setVendorContactPerson(e.target.value);
  };
  const handleAddress = (e) => {
    setVendorAddress(e.target.value);
  };
  const handleCost = (e) => {
    setVendorCost(e.target.value);
  };
  const handleGST = (e) => {
    setVendorGST(e.target.value);
  };
  const handleQuotes = (e) => {
    setVendorQuotes(e.target.value);
  };

  return (
    <ThemeProvider theme={theme}>
    <div>
      <button
        className='btn btn-secondary deca-btn-yellow a-update-email-alert'
        onClick={handleClickOpen}
        disabled={some >= 4 || approved === 'Approved'}
      >
        Add Vendor
      </button>

      <Dialog
        onClose={handleClose}
        aria-labelledby='customized-dialog-title'
        open={open}
      >
        <CustomDialogTitle onClose={handleClose}>
          <p style={{ fontSize: '1.7em' }}>Add Vendor</p>
        </CustomDialogTitle>

        <CustomDialogContent dividers>
          <form
            className='form-horizontal '
            style={{ backgroundColor: '#eaf7fdcc' }}
            onSubmit={(event) => {
              event.preventDefault();

              props.addVendor(
                vendorName,
                vendorEmail,
                vendorAddress,
                vendorCost,
                vendorQuotes,
                vendorContactPerson,
                vendorGST
              );
              setOpen(false);
            }}
          >
            <div className='form-group'>
              <div className='col-sm-10'>
                <TextField
                  type='text'
                  className=''
                  id='Startdate'
                  label='Enter vendor name:'
                  onChange={handleName}
                  style={{ border: 'none' }}
                  required
                />
              </div>
              <div className='col-sm-10'>
                <TextField
                  type='Contact Person'
                  className=''
                  id='Startdate'
                  label='Enter contact person name:'
                  onChange={handleContactPerson}
                  style={{ border: 'none', marginTop: '5px' }}
                  required
                />
              </div>
              <div className='col-sm-10'>
                <TextField
                  type='email'
                  className=''
                  id='Startdate'
                  label='Enter project email:'
                  onChange={handleEmail}
                  style={{ border: 'none', marginTop: '5px' }}
                  required
                />
              </div>

              <div className='col-sm-10'>
                <TextField
                  type='text'
                  rows={5}
                  className=''
                  id='Startdate'
                  label='Enter address:'
                  onChange={handleAddress}
                  style={{ border: 'none', marginTop: '5px' }}
                  required
                />
              </div>
              <div className='col-sm-10'>
                <TextField
                  type='text'
                  className=''
                  id='Startdate'
                  label='GST'
                  onChange={handleGST}
                  style={{ border: 'none', marginTop: '5px' }}
                />
              </div>
              <div className='col-sm-10'>
                <TextField
                  type='number'
                  className=''
                  id='Startdate'
                  min='0'
                  step='0.01'
                  label='Enter quote cost:'
                  onChange={handleCost}
                  style={{ border: 'none', marginTop: '5px' }}
                />
              </div>
            </div>
            <div className='form-group'>
              <div className='col-sm-10'>
                <TextField
                  type='date'
                  id='Startdate'
                  className=' date-color'
                  onChange={handleQuotes}
                  label='Propose project complete date: '
                  min={dayjs().format('YYYY-MM-DD')}
                  InputProps={{
                    inputProps: { min: dayjs().format('YYYY-MM-DD') },
                  }}
                  defaultValue={dayjs().format('YYYY-MM-DD')}
                  style={{ border: 'none' }}
                  data-date-format='YYYY MM DD'
                />
              </div>
            </div>

            <div className='form-group'>
              <div className='col-sm-offset-2 col-sm-10'>
                <button
                  style={{ marginLeft: '53%', marginTop: '5%' }}
                  onClick={handleClose}
                  type='button'
                  className='btn muted-button  deca-btn-orange a-btn-cancel'
                >
                  Cancel
                </button>

                <button
                  className='btn btn-secondary deca-btn-yellow a-update-email-alert'
                  style={{ marginLeft: '2%', marginTop: '5%' }}
                >
                  Add Vendor
                </button>
              </div>
            </div>
          </form>
        </CustomDialogContent>
      </Dialog>
    </div>
    </ThemeProvider>
  );
};
export default AddVendor;
